import React from 'react';
import { Trophy, AlertTriangle, CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Progress } from '../ui/progress';
import { cn } from '../../lib/utils';

function BehaviorScore({ stats, activities }) {
  const calculateBehaviorScore = () => {
    if (!activities || activities.length === 0) return 100;
    const totalRisk = activities.reduce((sum, a) => sum + (a.risk_score || 0), 0);
    const avgRisk = totalRisk / activities.length;
    return Math.max(0, Math.round(100 - avgRisk * 2));
  };

  const score = calculateBehaviorScore();

  const toneClass =
    score >= 80
      ? 'text-success'
      : score >= 60
      ? 'text-primary'
      : score >= 40
      ? 'text-warning'
      : 'text-destructive';

  const barClass =
    score >= 80
      ? 'bg-success'
      : score >= 60
      ? 'bg-primary'
      : score >= 40
      ? 'bg-warning'
      : 'bg-destructive';

  const getScoreIcon = () => {
    const cls = cn('h-14 w-14', toneClass);
    if (score >= 80) return <Trophy className={cls} />;
    if (score >= 60) return <CheckCircle2 className={cls} />;
    return <AlertTriangle className={cls} />;
  };

  const getScoreLabel = () => {
    if (score >= 80) return 'Excellent';
    if (score >= 60) return 'Good';
    if (score >= 40) return 'Fair';
    return 'Needs Attention';
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Trust Score</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-4">
          <div>{getScoreIcon()}</div>
          <div className="flex-1">
            <div className="flex items-baseline gap-1">
              <span className={cn('text-5xl font-bold tabular-nums', toneClass)}>{score}</span>
              <span className="text-base text-muted-foreground">/ 100</span>
            </div>
            <div className={cn('text-sm font-medium', toneClass)}>{getScoreLabel()}</div>
            <Progress value={score} className="mt-3 h-2.5" indicatorClassName={barClass} />
          </div>
        </div>
        <p className="text-xs text-muted-foreground mt-3">
          Based on {activities?.length || 0} activities. Higher is better.
        </p>
      </CardContent>
    </Card>
  );
}

export default BehaviorScore;
